<img
  #imgEl
  class="profile-photo"
  [src]="dataUrl$ | async"
  loading="lazy"
  decoding="async"
  alt="User profile photo"
  title="User profile photo"
/>
